/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Previous_AriaInputs */

const en_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous Event`)
};

const fr_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement precedent`)
};

const de_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Ereignis`)
};

const it_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento precedente`)
};

const ru_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущее событие`)
};

const es_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento anterior`)
};

const zh_cn2_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一活动`)
};

const ja_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前回のイベント`)
};

const hi_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला कार्यक्रम`)
};

const pt_pt2_video_export_preview_previous_aria = /** @type {(inputs: Video_Export_Preview_Previous_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento anterior`)
};

/**
* | output |
* | --- |
* | "Previous Event" |
*
* @param {Video_Export_Preview_Previous_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_previous_aria = /** @type {((inputs?: Video_Export_Preview_Previous_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Previous_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preview_previous_aria(inputs)
	if (locale === "de") return de_video_export_preview_previous_aria(inputs)
	if (locale === "it") return it_video_export_preview_previous_aria(inputs)
	if (locale === "ru") return ru_video_export_preview_previous_aria(inputs)
	if (locale === "es") return es_video_export_preview_previous_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preview_previous_aria(inputs)
	if (locale === "ja") return ja_video_export_preview_previous_aria(inputs)
	if (locale === "hi") return hi_video_export_preview_previous_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preview_previous_aria(inputs)
	return en_video_export_preview_previous_aria(inputs)
});